module.exports = __webpack_public_path__ + "static/img/rain.6d5a57a0.png";